import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { DisruptionPnrGroupRow } from '@/lib/disruptions/types';
import { PnrOperationCenter } from '@/routes/disruptions/roster-pnr-drawer';
import { PassengerSearch } from './passenger-search';

// /passengers — "find this passenger" as a surface of its own (sidebar ›
// Operation › Passengers). The SAME search the dashboard hero carries: PNR /
// name / ticket / flight across the last 24 hours, tenant-wide; a hit opens the
// full PnrOperationCenter right here (flight resolution, hotel, vouchers,
// transport, care) — the operator never leaves the page.
//
// Layout (frontend-conventions §18.1): full width, no page scroll — the results
// list is its own bounded scroll box inside PassengerSearch.

export function PassengersRoute() {
  const { t } = useTranslation('cases');
  const [activeHit, setActiveHit] = useState<DisruptionPnrGroupRow | null>(null);

  return (
    <main
      className="density-page flex h-full min-h-0 w-full flex-col gap-4 overflow-y-auto p-4 lg:px-6"
      data-testid="passengers-route"
    >
      <header className="shrink-0">
        <h1 className="text-2xl font-semibold">{t('passengers.title')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('passengers.subtitle')}</p>
      </header>

      <PassengerSearch onOpen={setActiveHit} />

      {activeHit ? (
        <PnrOperationCenter
          scope={{ kind: 'case', caseUrn: activeHit.caseUrn }}
          group={activeHit}
          onClose={() => setActiveHit(null)}
        />
      ) : null}
    </main>
  );
}
